import { render, staticRenderFns } from "./TheMainPage.vue?vue&type=template&id=f207a690&scoped=true&"
import script from "./TheMainPage.vue?vue&type=script&lang=js&"
export * from "./TheMainPage.vue?vue&type=script&lang=js&"
import style0 from "./TheMainPage.vue?vue&type=style&index=0&id=f207a690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f207a690",
  null
  
)

export default component.exports